import { MenuItemType } from'./index'

const TaxClaimant: MenuItemType[] = [
  { key:'vilacon', label:'Vila Contábil', isTitle: true },
  {
    key:'docs',
    label:'Documentos',
    icon:'fa-regular fa-folder-open',
    children: [
      {
        key:'managerDocs',
        label:'Meus documentos',
        url:'/txclmt/documents',
      },
    ],
  },
];

export default TaxClaimant